
import React from 'react';
import ImageTextListManager from '../common/ImageTextListManager';
import mainContext from '../../../contexts/mainContext';
import { addBabaySitterHaveController, deleteData, getBabaySitterHaveController } from '../../../Controllers/AppManagement/babySitter';
import { __constants, __snackBarText, __snackBarSeverity } from '../../../constants';

export default function BabySitterHave() {
  const { setProfileNavTitle } = React.useContext(mainContext);
  return (
    <ImageTextListManager
      navTitle="Babysitter assets"
      dialogTitle="Add new have"
      textLabel="Have"
      getData={getBabaySitterHaveController}
      addData={addBabaySitterHaveController}
      deleteData={deleteData}
      editTitle="Update have"
      setProfileNavTitle={setProfileNavTitle}
      __constants={__constants}
      __snackBarText={__snackBarText}
      __snackBarSeverity={__snackBarSeverity}
      mainContext={mainContext}
    />
  );
}